import { render, staticRenderFns } from "./LayoutSecured.vue?vue&type=template&id=5f310dbd&scoped=true&"
import script from "./LayoutSecured.vue?vue&type=script&lang=js&"
export * from "./LayoutSecured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f310dbd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5f310dbd', component.options)
    } else {
      api.reload('5f310dbd', component.options)
    }
    module.hot.accept("./LayoutSecured.vue?vue&type=template&id=5f310dbd&scoped=true&", function () {
      api.rerender('5f310dbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/LayoutSecured.vue"
export default component.exports